import { compose, hoistStatics, withProps } from 'recompose';
import { translate } from 'react-i18next';
import DataCell from './DataCell';
import gh from '../grid.helper';

const enhance = compose(
  withProps((props) => {
    const { column,
      item,
      service,
      destroyItem,
      updateData } = props;

    const value = gh.getCellValue(column, item, service, updateData, destroyItem);
    const classNaming = gh.getCellClass(value);
    return {
      value,
      classNaming,
      ...props,
    };
  }),
  translate('portal'),
);

export default hoistStatics(enhance)(DataCell);



// WEBPACK FOOTER //
// ./src/components/list/grid/dataCell/index.js